export default __webpack_public_path__ + "static/media/instagram_post_1080x1080px.e776ce8b.png";